export class PmdModalBackdropOptions {
  animate = true;

  constructor(options: PmdModalBackdropOptions) {
    Object.assign(this, options);
  }
}
